import { style } from 'typestyle';
import { primaryTextColor } from 'src/common-ui/theme';

const userMessageRow = style({
  $debugName: 'userMessageRow',
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'flex-start',
  width: '100%',
});

const aiMessageRow = style({
  $debugName: 'aiMessageRow',
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  width: '100%',
  gap: '12px',
  marginBottom: '1rem'
});

const userMessageBubble = style({
  $debugName: 'userMessageBubble',
  color: primaryTextColor,
  padding: '12px 16px',
  borderRadius: '12px',
  maxWidth: '80%',
  fontSize: '0.9rem',
  lineHeight: '1.5',
  wordWrap: 'break-word',
});

const aiMessageText = style({
  $debugName: 'aiMessageText',
  backgroundColor: '#E5E7EB',
  color: primaryTextColor,
  fontSize: '0.9rem',
  lineHeight: '1.5',
  maxWidth: '80%',
  wordWrap: 'break-word',
  borderRadius: 15,
  padding: 10
});

const aiIcon = style({
  $debugName: 'aiIcon',
  display: 'flex',
  alignItems: 'start',
  justifyContent: 'center',
  flexShrink: 0,
  paddingTop: 10,
  width: '24px',
  height: '24px',
});

export default {
  userMessageRow,
  aiMessageRow,
  userMessageBubble,
  aiMessageText,
  aiIcon,
};
